/// <reference path="../router/path.ts" />
/// <reference path="../router/path.ts" />
import store from "store";

import { User } from "../models/login";
import { UserRole } from "../models/types/graphql-global-types";
import { BusinessClient } from "../models/types/me";
import { IUserRoleDictionaryEntry, UserRoleDictionary } from "../models/user-role-dictionary";


import { isIE, requiresInteraction, tokenInfo, Request } from "./authTypes";
import { msalConfig, loginRequest, tokenRequestCentralgateway, apiConfig, } from "./authConfig";
import { AccountInfo, AuthenticationResult, PublicClientApplication } from "@azure/msal-browser";


import { Login_login_user_loackerCompany } from "../models/types/Login";
import { dropItemStringValue, dropItemNumberValue } from "../models/dropbox";


const useRedirectFlow = isIE();

interface UserProfileApiResponse {
    email: string;
    fullName: string;
    companyNumber: string;
    personalType: string;
    assignedLocations: string;
    countryCode: string;
    personalNumber: string;
    roles: string[];
}

type ExtendedUser = User & {
    personalType?: string;
    country?: string;
    personalNumber?: string;
};

enum STORE_KEYS {
    CENTRALGATEWAYTOKEN = "centralgateway_token",
    EXPIRATION_DATE_TOKEN = "loacker_expirationDate_Token",
    ACCOUNT = 'account',
    USER = "loacker_user",
    HOMEACCOUNTID = "homeAccountId",
    BUSINESSCLIENT = "loacker_business_client",
    ROLE = "loacker_role",
}

const msalApp = new PublicClientApplication(msalConfig);
export class LoackerService {

    private static readonly allowedRoles = new Set<string>(Object.values(UserRole));

    public static async onSignOut() {

        localStorage.setItem("account", '')
        return msalApp.logoutPopup();
    }

    public static async onSignIn(redirect: boolean) {
        if (redirect) {
            console.log('loginRedirect');
            await msalApp.loginRedirect(loginRequest);
            return "OK";
        }
        console.log('onSignIn');
        console.log(loginRequest);


        try {

            const response = await msalApp.loginPopup(loginRequest);

            await this.handleSignInResponse(response);

            var profileUser = await LoackerService.fetchUserProfile();

            console.log(profileUser);

            return "OK";

        } catch (err) {

            return `${err}`;
        }
    }

    public static async handleSignInResponse(response: AuthenticationResult) {
        if (response !== null) {
            console.log('handleSignInResponse');

            const defaultCompany: Login_login_user_loackerCompany = {
                __typename: "LoackerCompany",
                companyNumber: 140,
                name: "LoackerCompany",
                email: "kundencenter@loacker.cc",
                phone: "+43 5523 502 1111",
                imprint: "https://www.loacker.cc/impressum/",
                dataPolicy: "https://www.loacker.cc/datenschutzerklaerung/",
                termsAndConditions: "https://www.loacker.cc/agb",
            };

            //const stringRoles = account.account.idToken.extension_CustomRole.split(",");
            const stringRoles = [''];

            let roles: UserRole[] = [];
            if (!response.account) { return false; }


            const userName = response.account.username.toLowerCase();

            const userNames = response.account?.name ? response.account.name.split(' ') : null;
            const user: User = {
                __typename: "User",
                firstName: userNames ? userNames[0] : "",
                lastName: userNames ? userNames[1] : "",
                email: response.account ? userName : "",
                roles: roles,
                isActive: true,
                lastLogin: "",
                telNr: "",
                position: "",
                recyNumber: null,
                acceptedAgbAt: true,
                assignedBusinessClients: null,
                loackerCompany: defaultCompany,
                assignedLocations: null,
            };

            store.set(STORE_KEYS.USER, user);
            store.set(STORE_KEYS.ACCOUNT, response.account);
            store.set(STORE_KEYS.HOMEACCOUNTID, response.account?.homeAccountId);


            return true;

        } else {
            this.getAccounts();
            return true;
        }
    }


    public static getAccounts() {
        /**
         * See here for more info on account retrieval: 
         * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
         */
        const currentAccounts = msalApp.getAllAccounts();

        if (currentAccounts === null) {
            console.error("No accounts detected!");
            return;
        } else if (currentAccounts.length > 1) {
            console.warn("Multiple accounts detected.");
            // Add choose account code here
            const account = msalApp.getAccountByUsername(currentAccounts[0].username);
            store.set(STORE_KEYS.ACCOUNT, account);
            store.set(STORE_KEYS.HOMEACCOUNTID, account?.homeAccountId);

        } else if (currentAccounts.length === 1) {
            console.warn("yes");
            const account = msalApp.getAccountByUsername(currentAccounts[0].username);
            store.set(STORE_KEYS.ACCOUNT, account);
            store.set(STORE_KEYS.HOMEACCOUNTID, account?.homeAccountId);
        }
    }

    public static async acquireCentralGatewayToken(): Promise<string | undefined> {
        try {

            let tokenFounded = store.get(STORE_KEYS.CENTRALGATEWAYTOKEN);
            if (!tokenFounded) {
                let response = await this.tokenSilent(tokenRequestCentralgateway);
                console.log("tokenSilent was ok ");
                if (!response) {
                    response = await msalApp.acquireTokenPopup(tokenRequestCentralgateway);
                }

                this.StoreCentralGatewayToken(response);
                return this.getToken();
            }

            const currentDate = new Date();
            const expirationDate = new Date(store.get(STORE_KEYS.EXPIRATION_DATE_TOKEN) as Date);

            if (expirationDate !== null && currentDate > expirationDate) {
                // console.log('Token has expired');
                const response = await this.tokenSilent(tokenRequestCentralgateway);
                this.StoreCentralGatewayToken(response);
            }

            return this.getToken();

        } catch (error: any) {
            // console.log("AquireTokenSilent failure");
            if (requiresInteraction(error.errorCode)) {
                // return useRedirectFlow ? msalApp.acquireTokenRedirect(tokenRequestNews) : msalApp.acquireTokenPopup(tokenRequestNews);
                throw error;
            } else {
                console.error("Non-interactive error:", error.errorCode);
                throw error;
            }
        }
    }


    public static async fetchUserProfile(): Promise<boolean> {

        console.log('fetchUserProfile...');
        let sucess: boolean = false;
        let loggedUser = this.getUser();

        if (loggedUser === undefined) {
            console.log('fetchUserProfile... loggedUser');
            sucess = false;
            return sucess;
        }

        if (loggedUser.roles.length >= 1) {
            return true;
        }

        const token = await LoackerService.acquireCentralGatewayToken();
        if (!token) {
            console.log('fetchUserProfile... token!');
            return false;
        }

        try {
            const response = await fetch(`${apiConfig.centralGatewayAPIUri}auth/profile/me`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                mode: 'cors'
            });

            if (!response.ok) {
                console.log(`fetchUserProfile... profile request failed ${response.status}`);
                return false;
            }

            const result = await response.json() as UserProfileApiResponse;
            const userNames = (result.fullName || "").split(' ').filter(Boolean);
            const parsedCompanyNumber = Number(result.companyNumber);
            const extendedLoggedUser = loggedUser as ExtendedUser;
            const runtimeLoggedUser = extendedLoggedUser as any;

            extendedLoggedUser.firstName = userNames[0] ?? extendedLoggedUser.firstName;
            extendedLoggedUser.lastName = userNames.slice(1).join(' ') || extendedLoggedUser.lastName;
            extendedLoggedUser.roles = this.mapApiRoles(result.roles);

            if (extendedLoggedUser.loackerCompany) {
                extendedLoggedUser.loackerCompany.companyNumber = Number.isFinite(parsedCompanyNumber)
                    ? parsedCompanyNumber
                    : extendedLoggedUser.loackerCompany.companyNumber;
                extendedLoggedUser.loackerCompany.name = result.fullName ?? "";
            }

            runtimeLoggedUser.personalType = result.personalType ?? "";
            runtimeLoggedUser.assignedLocations = result.assignedLocations ?? "";
            runtimeLoggedUser.country = result.countryCode ?? "";
            runtimeLoggedUser.personalNumber = result.personalNumber ?? "";

            store.set(STORE_KEYS.USER, extendedLoggedUser);
            sucess = true;
        } catch (err) {
            console.log(err);
            sucess = false;
        }

        return sucess;

    }

    private static mapApiRoles(roles: string[] | undefined): UserRole[] {
        if (!roles || roles.length === 0) {
            return [];
        }

        return roles
            .map((role) => role?.trim())
            .filter((role): role is string => Boolean(role) && this.allowedRoles.has(role))
            .map((role) => role as UserRole)
            .filter((role, index, allRoles) => allRoles.indexOf(role) === index);
    }

    public static StoreCentralGatewayToken(response: AuthenticationResult | null) {
        if (response !== null) {
            console.log('StoreCentralGatewayToken');

            store.set(STORE_KEYS.CENTRALGATEWAYTOKEN, response.accessToken);
            store.set(STORE_KEYS.EXPIRATION_DATE_TOKEN, response.expiresOn);

        } else {
            this.getAccounts();
        }
    }

    public static async tokenSilent(argRequest: Request) {
        console.log('tokenSilent');
        argRequest.account = this.getAzureAccount();
        let response = await msalApp.acquireTokenSilent(argRequest);
        if (!response) {
            response = await msalApp.acquireTokenPopup(argRequest);
        }

        return response;
    }

    public static getAzureAccount(): AccountInfo {
        return store.get(STORE_KEYS.ACCOUNT, undefined);
    }

    public static getUserRoleDictionaryEntry(): IUserRoleDictionaryEntry {
        const roles = LoackerService.getUserRoles();
        const role = roles ? roles[0] : undefined;
        const entry = UserRoleDictionary[role || ""];
        return entry ? entry : UserRoleDictionary[UserRole.BUSINESS_CLIENT];
    }

    public static getUser(): User | undefined {
        return store.get(STORE_KEYS.USER);
    }

    public static logout() {
        msalApp.logout();
        store.clearAll();
    }

    public static getToken(): string | undefined {
        return store.get(STORE_KEYS.CENTRALGATEWAYTOKEN, undefined);
    }

    public static isLoggedIn(): boolean {
        return store.get(STORE_KEYS.USER, undefined) !== undefined;
    }

    public static getUserRoles(): UserRole[] | undefined {
        const user = store.get(STORE_KEYS.USER);
        return user ? user.roles : undefined;
    }

    public static isAdmin(): boolean {
        return LoackerService.hasRole(UserRole.ADMIN);
    }
    public static isTester(): boolean {
        return LoackerService.hasRole(UserRole.TESTER) || LoackerService.hasRole(UserRole.ADMIN);
    }
    public static hasToManuallyEnterAccountNumber(): boolean {
        const roles = LoackerService.getUserRoles();
        const role = roles ? roles[0] : undefined;

        return role === UserRole.ADMIN || role === UserRole.SuperValue;
    }

    public static getBusinessClient(): BusinessClient | undefined {
        return store.get(STORE_KEYS.BUSINESSCLIENT, undefined);
    }

    public static setBusinessClient(businessClient: BusinessClient) {
        store.set(STORE_KEYS.BUSINESSCLIENT, businessClient);
    }

    public static removeBusinessClient() {
        store.remove(STORE_KEYS.BUSINESSCLIENT);
    }

    public static hasRole(role: UserRole): boolean {
        const roles = LoackerService.getUserRoles();
        return roles ? roles.includes(role) : false;
    }


}


export class DropdowndataService {



    public static createDropboxItem = (entity: any): dropItemStringValue => {
        const drop =
            {
                value: entity.RowKey ? entity.RowKey : "",
                label: entity.Label ? entity.Label : "",
            } as dropItemStringValue;

        return drop;
    }

    public static async fetchSites(): Promise<any[] | undefined> {

        // console.log('fetchSites...');
        const token = await LoackerService.acquireCentralGatewayToken();

        if (!token) {
            //  showSnackbar("No Token", SnackbarSeverity.ERROR);
            return undefined;
        }

        // setLoading(true);
        const url = new URL(`${apiConfig.centralGatewayAPIUri}Site`);
        const authString = `Bearer ${token}`;

        const response = fetch(url.href, {
            method: "GET",
            headers: {
                Authorization: authString,
                "Content-Type": "application/json",
            },
            mode: 'cors'
        }).then(async (response) => {
            if (response && response.status !== 404) {
                const data = await response.json();

                const dropSite = data.map((entity: any) => {
                    return this.createDropboxItem(entity)
                });

                store.set("dropSite", dropSite);

                return data;
            }

            return undefined;

        }).catch((err) => {
            // console.log(err)
            return undefined;
        });

        return response;

    }



    public static getSitesOptions(): dropItemStringValue[] | undefined {
        const dropData = store.get("dropSite");
        return dropData ? dropData : undefined;
    }


}